import { render, staticRenderFns } from "./Junto.vue?vue&type=template&id=4f71b0e2&"
import script from "./Junto.vue?vue&type=script&lang=js&"
export * from "./Junto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports